import { IPaymentReviewId } from "./paymentReviewId.types"

export class PaymentReviewId implements IPaymentReviewId {
  constructor(
    public id: number,
    public name: string,
    public type: string,
  ) {}
}
